import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateService } from '@services/translate.service';

@Injectable()
export class MatPaginatorFlow {
  constructor(private translateService: TranslateService) {}

  getPaginatorIntl() {
    const paginatorIntl = new MatPaginatorIntl();

    paginatorIntl.itemsPerPageLabel = this.translateService.translate('paginatorItemsPerPage');
    paginatorIntl.nextPageLabel = this.translateService.translate('paginatorNextPage');
    paginatorIntl.previousPageLabel = this.translateService.translate('paginatorPreviousPage');
    paginatorIntl.firstPageLabel = this.translateService.translate('paginatorFirstPage');
    paginatorIntl.lastPageLabel = this.translateService.translate('paginatorLastPage');
    paginatorIntl.getRangeLabel = this.getRangeLabel.bind(this);

    return paginatorIntl;
  }

  // itemsPerPageLabel = 'Kohteita per sivu';
  // nextPageLabel = 'Seuraava sivu';
  // previousPageLabel = 'Edellinen sivu';
  // firstPageLabel = 'Ensimmäinen sivu';
  // lastPageLabel = 'Viimeinen sivu';

  getRangeLabel = (page: number, pageSize: number, length: number) => {
    if (length === 0 || pageSize === 0) {
      return '0 / ' + length;
    }
    length = Math.max(length, 0);
    const startIndex = page * pageSize;
    // If the start index exceeds the list length, do not try and fix the end index to the end.
    const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
    return startIndex + 1 + ' - ' + endIndex + ' / ' + length;
  };
}
